module.exports = __webpack_public_path__ + "static/media/duanwuBg5.21d99bb8.png";